import { ZoomInOutlined, ZoomOutOutlined } from '@ant-design/icons';
import cx from 'classnames';
import React, { CSSProperties, FC } from 'react';
import { CanvasInfo } from '../../../../model/BadgeModel';
import { ExpandIcon } from '../../../../resources/Icons';
import { MenuItems, withMenuActions } from '../../../graphic';
import styles from './zoomMenu.module.scss';

const ExpandStyle: CSSProperties = { fontSize: 28 };
const ZoomStyle: CSSProperties = { fontSize: '1.33em' };

const ZoomMenu: FC<CanvasInfo> = withMenuActions(({ disabled, handleMenuActions }) => {
	return (
		<div className={styles.zoomMenuBar}>
			<ul>
				<li className={cx({ [styles.disabled]: disabled })} key={MenuItems.ExtendZoom} onClick={() => handleMenuActions(MenuItems.ExtendZoom)}>
					<span title={_('ExtendZoom')}>
						<ExpandIcon style={ExpandStyle} />
					</span>
				</li>
				<li className={cx({ [styles.disabled]: disabled })} key={MenuItems.ZoomOut} onClick={() => handleMenuActions(MenuItems.ZoomOut)}>
					<span title={_('ZoomOut')}>
						<ZoomOutOutlined style={ZoomStyle} />
					</span>
				</li>
				<li className={cx({ [styles.disabled]: disabled })} key={MenuItems.ZoomIn} onClick={() => handleMenuActions(MenuItems.ZoomIn)}>
					<span title={_('ZoomIn')}>
						<ZoomInOutlined style={ZoomStyle} />
					</span>
				</li>
			</ul>
		</div>
	);
});

export { ZoomMenu };
